export default __webpack_public_path__ + "static/media/illustration.18d0943b.svg";